export default __webpack_public_path__ + "static/upstart-191bd2d74f0370ae528d62eafbcf43d6.png";